<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-toolbar color="blue darken-4" dark>

          <v-toolbar-title>Cirurgias propostas</v-toolbar-title>

          <v-spacer></v-spacer>

        </v-toolbar>

        <v-list two-line>

          <template v-for="(item, index) in getProposedSurgeries">

            <v-list-tile
              :key="index"
              avatar
              ripple
              @click="toggle(index)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">Status: {{ item.headline }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>Cirurgia: {{ item.subtitle }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>Horário {{ item.action }}</v-list-tile-action-text>
                <!-- <v-icon
                  v-if="selected.indexOf(index) < 0"
                  color="grey lighten-1"
                >
                  star_border
                </v-icon>

                <v-icon
                  v-else
                  color="yellow darken-2"
                >
                  star
                </v-icon> -->
              </v-list-tile-action>

            </v-list-tile>
            <v-divider
              v-if="index + 1 < items.length"
              :key="index"
            ></v-divider>

          </template>
        </v-list>

      </v-card>

      <v-btn
        color="pink"
        @click="dialogCreated = true"
        dark
        absolute
        bottom
        right
        fab
        style="margin-bottom: 38px; margin-right: 10px;"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-flex>

    <div class="text-center">
      <v-dialog v-model="dialogCreated" fullscreen hide-overlay transition="dialog-bottom-transition">
        <!-- <create-schedule /> -->
      </v-dialog>
    </div>

  </v-layout>
</template>

<script>
  // import CreateSchedule from '../../components/surgery-center/create'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    mounted () {
      this.loading()
      this.$bus.$on('closeDialogScheduleProposed', this.closeDialogCreate)
    },
    computed: {
      ...mapGetters({ customer: 'customer', auth: 'auth' }),
      ...mapGetters('schedule', ['getProposedSurgeries']),
      ...mapGetters('app', ['getTheme', 'getDevice'])
    },
    components: {
      // CreateSchedule
    },
    methods: {
      ...mapActions('schedule', ['setProposedSurgeries']),
      closeDialogCreate () {
        this.dialogCreated = false
      },
      loading () {
        this.setProposedSurgeries({ date: new Date().toISOString().substr(0, 10), doctor: this.auth.auth.myClinic.crm, customer: this.auth.auth.user.customer })
      },
      toggle (item) {
        console.log(item)
      },
      save () {}
    },
    data () {
      return {
        selected: [2],
        proposedSurgeries: {},
        valid: false,
        dialogCreated: false,
        items: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/surgery-center/list.vue